import { useCallback } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { Coordinate, coordinatesActions } from "features/coordinates/coordinatesSlice";
import { undoRedoActions } from "features/undoRedo";

/**
 * Removes a placed coordinate and pushes the matching undo entry.
 *
 * Shared because removal is reachable two ways: the remove button on desktop, and a
 * proximity tap from `useMobileCoordinate` on touch, where the button takes no pointer
 * input of its own.
 */
export function useRemoveCoordinate() {
    const dispatch = useAppDispatch();

    return useCallback(
        (coord: Coordinate) => {
            dispatch(
                undoRedoActions.push({
                    description: "Remove coordinate",
                    undoCallback: () => {
                        dispatch(coordinatesActions.addCoordinate(coord));
                    },
                    redoCallback: () => {
                        dispatch(coordinatesActions.removeCoordinate(coord.id));
                    },
                }),
            );
            dispatch(coordinatesActions.removeCoordinate(coord.id));
            dispatch(coordinatesActions.setHideCoordinateGizmo(false));
        },
        [dispatch],
    );
}
